import React from "react";
import { HiOutlineSearch } from "react-icons/hi";
import InputForm from "../../../Category/Filter/Common/InputForm";

const Search = () => {
  return (
    <div className="border-b border-darkGreen border-opacity-40 px-2 py-8">
      <InputForm
        title={"Search"}
        titleClassName="mb-4 !text-base"
        icon={<HiOutlineSearch />}
        placeholder="Search"
      />
    </div>
  );
};

export default Search;
